(() => {
  'use strict';
  if (window.FXLandingTrailer) return;
  window.FXLandingTrailer = true;
  const bindings = new WeakSet();
  const videos = {
    game: {
      id: 'pEcQ2G51W1c',
      youtube: 'https://www.youtube.com/watch?v=pEcQ2G51W1c',
      title: 'Pinball FX VR™ — Official game trailer',
      frameTitle: 'Pinball FX VR™ — Official launch trailer by Zen Studios',
      closeLabel: 'Close game trailer',
      credit: 'Official Zen Studios™ trailer',
      help: 'Requires internet access. If the player does not load, open the trailer on YouTube™.',
      poster: window.PinballFXV15.assets["assets/fx-landing-game-keyart.png"]
    },
    product: {
      id: '_2FT8b2TmNM',
      youtube: 'https://youtu.be/_2FT8b2TmNM',
      title: 'Arcade2TV™ Pinball FX™ Edition — Product video',
      frameTitle: 'Arcade2TV™ Pinball FX™ Edition — Product video by X-Arcade',
      closeLabel: 'Close product video',
      credit: 'X-Arcade product video',
      help: 'Requires internet access. If the player does not load, open the product video on YouTube™.',
      poster: window.PinballFXV15.assets["assets/arcade2tv-pinball-fx-product-film-poster.jpg"]
    }
  };
  let opener = null, activeModal = null;
  function stopTrailer() {
    const modal = activeModal;
    modal?.querySelector('[data-trailer-mount]')?.replaceChildren();
    if (modal?.open) modal.close();
    activeModal = null;
    if (opener?.isConnected) opener.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const play = event.target.closest('.fx-gameplay-landing [data-trailer-open]');
    const video = play && (videos[play.dataset.trailerVideo] || videos.product);
    if (play && window.location.protocol === 'file:') { window.open(video.youtube, '_blank', 'noopener,noreferrer'); return; }
    if (play) {
      const root = play.closest('.fx-gameplay-landing');
      const modal = root?.querySelector('#game-trailer-dialog');
      const mount = modal?.querySelector('[data-trailer-mount]');
      if (!modal || !mount) return;
      event.preventDefault(); opener = play; activeModal = modal; mount.replaceChildren();
      modal.querySelector('#game-trailer-title').textContent = video.title;
      modal.querySelector('[data-trailer-close]').setAttribute('aria-label', video.closeLabel);
      modal.querySelector('[data-trailer-youtube]').href = video.youtube;
      modal.querySelector('[data-trailer-credit]').textContent = video.credit;
      modal.querySelector('.game-trailer-help').textContent = video.help;
      mount.style.setProperty('--fx-trailer-poster', 'url("' + video.poster + '")');
      root.querySelectorAll('video').forEach(video => video.pause());
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + video.id + '?autoplay=1&playsinline=1&rel=0';
      iframe.title = video.frameTitle;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true; iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      mount.append(iframe);
      if (!bindings.has(modal)) {
        modal.addEventListener('cancel', e => { e.preventDefault(); stopTrailer(); });
        modal.addEventListener('click', e => { if (e.target === modal) stopTrailer(); });
        modal.addEventListener('close', () => mount.replaceChildren());
        bindings.add(modal);
      }
      modal.showModal(); modal.querySelector('[data-trailer-close]')?.focus();
    }
    if (event.target.closest('.fx-gameplay-landing [data-trailer-close]')) stopTrailer();
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden && activeModal?.open) stopTrailer(); });
  document.addEventListener('shopify:section:unload', event => { if (activeModal && event.target.contains(activeModal)) stopTrailer(); });
})();


